import { render, staticRenderFns } from "./Carousel1Wrapper.vue?vue&type=template&id=78e4f252&"
import script from "./Carousel1Wrapper.vue?vue&type=script&lang=js&"
export * from "./Carousel1Wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports